<template>
  <div class="container sign-in" :class="{'container-white' : color_theme === 'mobile', 'container-black' : color_theme === 'black'}">
    <article class="intro" style="padding-top: 2.5vw;">
      <h2 class="tit" :class="{'tit-white' : color_theme === 'mobile', 'tit-black' : color_theme === 'black'}" style="font-size: 2.75vw">{{ $t('label.qrLoginTitle') }}</h2>
    </article>
    <section class="sign-in-qrcode" style="margin-top: 30px; padding: 0; font-size: 1vw">
      <p class="time" v-if="!qrReLoad"><span>{{ $t('label.RemainTimeTxt') }} : </span>&nbsp;<em>{{ $tc('label.exTime', remainTime) }}</em></p>
      <p class="time" v-if="qrReLoad">
        <a class="btn focusable" @click="getQrCode" tabindex="0" style="margin: 0; padding: 0; font-size: 1vw">{{ $t('label.qrRefresh') }}</a>
      </p>
    </section>
    <section class="sign-in-qrcode" style="margin-top: 10px">
      <div class="qrcode-wrap" :class="{'qrcode-wrap-white' : color_theme === 'mobile', 'qrcode-wrap-black' : color_theme === 'black'}" style="height: auto">
        <p class="error" v-if="country && country!=='OTHER'">
          {{ $t('messages.WrongCountryCode', {'0': $t(`label.${country}`)}) }}
        </p>
        <div v-if="display.toLowerCase() === 'pin'">
          <div class="content-center" style="padding: 20px 0">
            <h4 style="font-size: 1.5vw; margin-bottom: 20px; white-space: pre-wrap">{{ $t('messages.MobilePinSignInTxt') }}</h4>
            <div v-if="qrCode !== ''" class="pin content-center" style="padding: 10px 0 15px 0"><em v-if="!qrReLoad" style="padding:15px; border-radius: 15px; background-color: white; color: #225b54">{{ pinCode }}</em></div>
            <div v-else class="pin content-center" style="padding: 10px 0 15px 0"><em style="padding:15px; border-radius: 15px; background-color: white; color: #225b54">{{ $t('messages.ExpiredCode') }}</em></div>
          </div>
        </div>
        <div v-else-if="display.toLowerCase() === 'qr'">
          <div style="padding: 20px 0">
            <h4 style="font-size: 1vw; margin-bottom: 0px; white-space: pre-wrap">{{ $t('messages.MobileQrSignInTxt') }}</h4>
            <template v-if="qrCode !== ''">
              <qrcode :value="qrCode" style="margin-top: 20px"></qrcode>
            </template>
            <template v-if="qrCode === ''">
              <div class="sample" style="margin-top: 20px">
                <img :src="require('@/assets/images/qrbg.png')"/>
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
            </template>
          </div>
        </div>
        <div v-else>
          <div style="padding: 20px 0">
            <h4 style="font-size: 1vw; margin-bottom: 0px; white-space: pre-wrap">{{ $t('messages.MobileQrSignInTxt') }}</h4>
            <template v-if="qrCode !== ''">
              <qrcode :value="qrCode" style="margin-top: 20px"></qrcode>
            </template>
            <template v-if="qrCode === ''">
              <div class="sample" style="margin-top: 20px">
                <img :src="require('@/assets/images/qrbg.png')"/>
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
            </template>
          </div>
          <div class="content-center" style="padding: 20px 0">
            <h4 style="font-size: 1vw; margin-bottom: 20px; white-space: pre-wrap">{{ $t('messages.MobilePinSignInTxt') }}</h4>
            <div v-if="qrCode !== ''" class="pin content-center" style="padding: 10px 0 15px 0"><em v-if="!qrReLoad" style="padding:15px; border-radius: 15px; background-color: white; color: #225b54">{{ pinCode }}</em></div>
            <div v-else class="pin content-center" style="padding: 10px 0 15px 0"><em style="padding:15px; border-radius: 15px; background-color: white; color: #225b54">{{ $t('messages.ExpiredCode') }}</em></div>
          </div>
        </div>
      </div>
    </section>
      <div class="btn-wrap qr" v-if="this.isShowingMobileBtn">
      <b-button class="btn focusable" @click="closeApp" tabindex="0">{{ $t('label.close') }}</b-button>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import Vue from "vue";
import VueNativeSock from "vue-native-websocket";
import store from "@/store/store";
import session from "@/utils/session";

import {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
} from '@/store/mutation_types';

const mutations = {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
}

export default {
  name: 'QrLogin',
  metaInfo() {
    return {
      title: "QrLogin"
    };
  },
  data() {
    return {
      show: true,
      polling: null,
      ttl: 60,
      remainTime: '00',
      timer: null,
      qrReLoad: false,
      webSocket: null,
      country: '',
      country_code: this.$store.state.country || this.$route.query.country,
      autoSignIn: this.$store.state.login_save || true,
      redirect_uri: this.$store.state.redirect_uri || this.$route.query.redirect_uri,
      return_type: this.$store.state.return_type || this.$route.query.return_type,
      color_theme: this.$store.state.color_theme || this.$route.query.theme || 'mobile',
      display: this.$store.state.display || this.$route.query.display || '',
      theme: session.get_theme() || 'tv',
      mobile_app_link: '',
      isShowingMobileBtn: true,
      isIDPW: this.$store.state.idpw,
      // country_list:  {
      //   'KR': 'ko',
      //   'US': 'en',
      //   'CA': 'en',
      //   'FR': 'fr',
      //   'SP': 'sp'
      // }
    }
  },
  mounted() {
    this.country = '';
    // this.$i18n.locale = this.country_list[this.country_code]
    this.$i18n.locale = (this.country_code === 'KR') ? 'ko' : 'en';

    const socket_url = process.env.VUE_APP_SOCKET_SERVER_QR;

    Vue.use(VueNativeSock, socket_url, {
      store: store,
      mutations: mutations,
      connectManually: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 3000,
    });

    this.openWebSocket();
    this.webSocket = this.$socket
    this.webSocket.onopen = () => {
      this.getQrCode()
    }
    this.webSocket.onmessage = data => {
      const msg = JSON.parse(data.data)
      if (msg.hasOwnProperty('qrCode')) {
        let qrCodeMsg = msg.qrCode
        // console.log('[CHECK] msg.qrCode : ', qrCodeMsg)
        console.log('[CHECK] dt : ', this.$store.state.qrDt)
        console.log('[CHECK] tc : ', this.$store.state.qrTc)
        console.log('[CHECK] rp : ', this.$store.state.qrRp)
        console.log('[CHECK] tm : ', this.$store.state.qrTm)
        console.log('[CHECK] sn : ', this.$store.state.qrSn)
        console.log('[CHECK] sm : ', this.$store.state.qrSm)
        qrCodeMsg = this.checkQrCode(qrCodeMsg)
        this.$store.commit('QR_CODE', qrCodeMsg)
        this.ttl = msg.ttl
      }
      if (msg.hasOwnProperty('pinCode')) {
        this.$store.commit('PIN_CODE', msg.pinCode)
      }
      if (msg.hasOwnProperty('access_token')) {
        if (['KR', 'US', 'CA'].includes(msg.mbr_no.substring(0, 2))) {
          this.$toastr.s(this.$t('messages.SignInComplete', {'0': this.$t('label.qrCode')}))
          setTimeout(() => {
            document.location.href = `${msg.redirect_uri}?access_token=${msg.access_token}&refresh_token=${msg.refresh_token}&mbr_no=${msg.mbr_no}&login_save=${this.autoSignIn}&return_type=${this.return_type}`;

          }, 1500)
        } else {
          this.country = 'OTHER'
        }
      }
      if (msg.hasOwnProperty('error')) {
        this.$bvModal.msgBoxOk(msg.error.message, {
          okTitle: this.$t('label.ok')
        })
      }
      if (msg.hasOwnProperty('code')) {
        if (['KR', 'US', 'CA'].includes(msg.user_number.substring(0, 2))) {
          if (msg.code_type) {
            if (msg.code_type === 'QR') {
              this.$toastr.s(this.$t('messages.SignInComplete', {'0': this.$t('label.qrCode')}))
            } else if (msg.code_type === 'PIN') {
              this.$toastr.s(this.$t('messages.SignInComplete', {'0': this.$t('label.pinCode')}))
            } else {
              this.$toastr.s(this.$t('messages.SignInCompleteDefault'))
            }
          } else {
            this.$toastr.s(this.$t('messages.SignInCompleteDefault'))
          }

          const locale = navigator.language || navigator.userLanguage;
          if (locale.indexOf('CA') < 0) {
            gtag('event', "login_complete", {
              "method": "QrLogin",
              "country_code": this.country_code,
              "login_save": this.autoSignIn
            });
          }

          setTimeout(() => {
            this.mobile_app_link = `${msg.redirect_uri}?code=${msg.code}&state=${msg.state}&oauth2_backend_url=${msg.oauth2_backend_url}&user_number=${msg.user_number}&login_save=${this.autoSignIn}`;
            // this.isShowingMobileBtn = true
            document.location.href = `${msg.redirect_uri}?code=${msg.code}&state=${msg.state}&oauth2_backend_url=${msg.oauth2_backend_url}&user_number=${msg.user_number}&login_save=${this.autoSignIn}`;
          }, 1500)
        } else {
          this.country = 'OTHER'
        }
      }
    }
  },
  methods: {
    goPage: function(page) {
      this.$store.commit('QR_CODE', '')
      this.$router.push({
        name: page
      });
    },
    goPageWithIdpw: function() {
      if (this.$store.state.idpw) {
        this.goPage('Home')
      }
    },
    closeApp() {
      window.HybridApp.closeWebview()
    },
    getQrCode() {
      if(this.webSocket.readyState === 1){
        Vue.prototype.$socket.send(JSON.stringify({
          "action": "qr-login",
          "redirect_uri": this.$store.state.redirect_uri,
          "return_type": this.$store.state.return_type,
          "login_save": this.autoSignIn,
          "svc_list": this.$store.state.svc_list,
          "country_code": this.country_code,
          // "country_code": this.country_code === 'SP' ? 'US' : this.country_code === 'FR' ? 'CA' : this.country_code,
          "language": this.$store.state.language,
          "cross_login": this.$store.state.cross_login,
          "except_new": this.$store.state.except_new,
          "terms_name": this.$store.state.terms_name,
          "third_party_service_name": this.$store.state.third_party_service_name,
          "show_login_type": this.$store.state.show_login_type,
          "response_type": this.$store.state.response_type,
          "client_id": this.$store.state.client_id,
          "state": this.$store.state.state
        }))
        this.qrReLoad = false
      } else {
        location.reload();
      }
    },
    openWebSocket() {
      const socket_url = process.env.VUE_APP_SOCKET_SERVER_QR;
      this.$connect(socket_url, {format: 'json'})
    },
    startTimer: function() {
      this.timer = setInterval(() => {
        if (this.ttl > 0) {
          this.ttl--;
        } else {
          clearInterval(this.timer);
          this.$store.commit('QR_CODE', '')
          this.qrReLoad = true;
        }
        this.remainTime = (this.ttl > 9 ? this.ttl : '0' + this.ttl)
      }, 1000);
    },
    checkQrCode: function(qrUrl) {
        console.log(this.country_code)
      const qrUrlSplit = qrUrl.split('?')
      const qrHost = qrUrlSplit[0]
      const qrParams = qrUrlSplit[1]
      // console.log('[CHECK] qrParams : ', qrParams)
      const qrSearchParams = new URLSearchParams(qrParams)
      // console.log('[CHECK] qrSearchParams : ', qrSearchParams)

      let qrSearchParamsString = qrSearchParams.toString()
      // console.log('[CHECK] qrSearchParamsString : ', qrSearchParamsString)
      if (qrSearchParams.has('link')) {
        const qrLink = qrSearchParams.get('link')
        // console.log('[CHECK] qrLink : ', qrLink)
        const qrLinkSplit = qrLink.split('?')
        const qrLinkHost = qrLinkSplit[0]
        const qrLinkParams = new URLSearchParams(qrLinkSplit[1])
        // console.log('[CHECK] qrLinkHost : ', qrLinkHost)
        // console.log('[CHECK] qrLinkParams : ', qrLinkParams)

        if (this.$store.state.qrDt) qrLinkParams.append('dt', this.$store.state.qrDt)
        if (this.$store.state.qrTc) qrLinkParams.append('tc', this.$store.state.qrTc)
        if (this.$store.state.qrRp) qrLinkParams.append('rp', this.$store.state.qrRp)
        if (this.$store.state.qrTm) qrLinkParams.append('tm', this.$store.state.qrTm)
        if (this.$store.state.qrSn) qrLinkParams.append('sn', this.$store.state.qrSn)
        if (this.$store.state.qrSm) qrLinkParams.append('sm', this.$store.state.qrSm)

        // console.log(qrLinkParams.toString())
        const resultLink = `${qrLinkHost}?${qrLinkParams.toString()}`
        // console.log('[CHECK] resultLink : ', resultLink)
        qrSearchParams.delete('link')
        const newSearch = new URLSearchParams()
        newSearch.append('link', resultLink)
        // console.log('[CHECK] newSearch : ', newSearch.toString())
        qrSearchParamsString = newSearch.toString() + '&' + qrSearchParams.toString()
      }
      // console.log('[CHECK] qrSearchParamsString : ', qrSearchParamsString)
      const result = `${qrHost}?${qrSearchParamsString}`
      // console.log('[CHECK] result : ', result)
      return result
    },
  },
  computed: {
    ...mapGetters({
      errorState: 'getErrorState'
    }),
    qrCode: function() {
      return this.$store.state.qrCode;
    },
    pinCode: function() {
      return this.$store.state.pinCode;
    }
  },
  watch: {
    qrCode: function(newVal) {
      if (newVal) {
        this.startTimer()
      } else {
        this.qrReLoad = true
      }
    },
  },
  beforeDestroy() {
    this.$disconnect()
    clearInterval(this.timer);
    clearInterval(this.polling)
  }
}
</script>
<style scoped>
.time{
  color: #225b54;
  font-weight: bolder !important;
}
</style>
